import moment from "moment";
import * as actionTypes from "./constants";
import * as Service from "./services";

const getDataList = (params, entity, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DATA_REQUEST });
            const res = await Service.getDataList(params, entity, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({
                        type: actionTypes.GET_DATA_SUCCESS,
                        response: regionData,
                        entity
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_DATA_FAILURE,
                        error: regionData,
                        entity
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_DATA_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_DATA_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const addData = (params, entity, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.ADD_DATA_REQUEST });
            const res = await Service.addData(params, entity, source);
            if (res && (res.status === 200 || res.status === 201)) {
                const regionData = res.data;
                if (regionData.success || entity === "client_standards") {
                    dispatch({ type: actionTypes.ADD_DATA_SUCCESS, response: regionData, entity });
                } else {
                    dispatch({ type: actionTypes.ADD_DATA_FAILURE, error: regionData, entity });
                }
            } else {
                dispatch({
                    type: actionTypes.ADD_DATA_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.ADD_DATA_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const getDataById = (id, entity, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DATA_BY_ID_REQUEST });
            const res = await Service.getDataById(id, entity, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success || entity === "client_standards" || entity === "client_standards_hierarchy") {
                    dispatch({
                        type: actionTypes.GET_DATA_BY_ID_SUCCESS,
                        response: regionData,
                        entity
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_DATA_BY_ID_FAILURE,
                        error: regionData,
                        entity
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_DATA_BY_ID_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_DATA_BY_ID_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const updateData = (id, params, entity, source = null) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.UPDATE_DATA_REQUEST });
            const res = await Service.updateData(id, params, entity, source);
            if (res && (res.status === 200 || res.status === 201)) {
                const building_typeData = res.data;
                if (building_typeData.success || entity === "client_standards" || entity === "asset_dynamic_dictionary") {
                    dispatch({
                        type: actionTypes.UPDATE_DATA_SUCCESS,
                        response: building_typeData,
                        entity
                    });
                } else {
                    dispatch({
                        type: actionTypes.UPDATE_DATA_FAILURE,
                        error: building_typeData,
                        entity
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.UPDATE_DATA_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_DATA_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};
// const updateDataPiechart = (id, params, entity) => {
//     return async dispatch => {
//         try {
//             dispatch({ type: actionTypes.GET_DATA_REQUEST });
//             const res = await Service.updateDataPiechart(id, params, entity);
//             if (res && (res.status === 200 || res.status === 201)) {
//                 const building_typeData = res.data;
//                 if (building_typeData.success) {
//                     dispatch({
//                         type: actionTypes.GET_DATA_SUCCESS,
//                         response: building_typeData,
//                         entity
//                     });
//                 } else {
//                     dispatch({
//                         type: actionTypes.GET_DATA_FAILURE,
//                         error: building_typeData,
//                         entity
//                     });
//                 }
//             } else {
//                 dispatch({
//                     type: actionTypes.GET_DATA_FAILURE,
//                     error: res.response && res.response.data,
//                     entity
//                 });
//             }
//         } catch (e) {
//             dispatch({
//                 type: actionTypes.GET_DATA_FAILURE,
//                 error: e.response && e.response.data,
//                 entity
//             });
//         }
//     };
// };

const updateDataEntityParams = (entityParams, entity) => {
    return async dispatch => {
        try {
            if (entityParams) {
                dispatch({
                    type: actionTypes.UPDATE_DATA_ENTITY_PARAMS_SUCCESS,
                    response: entityParams,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.UPDATE_DATA_ENTITY_PARAMS_FAILURE,
                error: entityParams,
                entity
            });
        }
    };
};

const getListForCommonFilter = (params, entity, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_LIST_FOR_COMMON_FILTER_REQUEST });
            const res = await Service.getListForCommonFilter(params, entity, source);
            if (res && res.status === 200) {
                const floorData = res.data;
                if (floorData.success) {
                    dispatch({
                        type: actionTypes.GET_LIST_FOR_COMMON_FILTER_SUCCESS,
                        response: floorData,
                        entity
                    });
                } else {
                    dispatch({
                        type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                        error: floorData,
                        entity
                    });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_LIST_FOR_COMMON_FILTER_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const exportData = (params, entity) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DATA_EXPORT_REQUEST });
            const response =
                entity === "client_standards" || entity === "client_standards_hierarchy" || entity === "entity"
                    ? await Service.getDataList(params, entity)
                    : await Service.exportData(params, entity);
            if (response && response.data) {
                const text = await new Response(response.data).text();
                if (text && text.split('"')[1] === "error") {
                    dispatch({ type: actionTypes.GET_DATA_EXPORT_SUCCESS, response: { error: text.split('"')[3] }, entity });
                    return true;
                } else {
                    dispatch({ type: actionTypes.GET_DATA_EXPORT_SUCCESS, response: {}, entity });
                }
            }
            const { data } = response;
            let fileName = "Export.xlsx";
            const contentDisposition = response.headers && response.headers["content-disposition"];
            if (contentDisposition) {
                const name = response.headers["content-disposition"].split("filename=");
                fileName = name[1].split('"')[1];
            } else if (entity === "client_standards") {
                fileName = `Client Standard ${moment().format("MM-DD-YYYY ")}.xlsx`;
            } else if (entity === "client_standards_hierarchy") {
                fileName = `Client Standard Hierarchy ${moment().format("MM-DD-YYYY ")}.xlsx`;
            }
            const downloadUrl = window.URL.createObjectURL(new Blob([data]));
            const link = document.createElement("a");
            link.href = downloadUrl;
            link.setAttribute("download", `${fileName}`); //any other extension
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (e) {}
    };
};

const getAllDataLogs = (id, params, entity, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_DATA_LOG_REQUEST });
            const res = await Service.getAllDataLogs(id, params, entity, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_ALL_DATA_LOG_SUCCESS, response: regionData, entity });
                } else {
                    dispatch({ type: actionTypes.GET_ALL_DATA_LOG_FAILURE, error: regionData, entity });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_DATA_LOG_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_DATA_LOG_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const restoreDataLog = (id, entity, params, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.RESTORE_DATA_LOG_REQUEST });
            const res = await Service.restoreDataLog(id, entity, params, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.RESTORE_DATA_LOG_SUCCESS, response: regionData, entity });
                } else {
                    dispatch({ type: actionTypes.RESTORE_DATA_LOG_FAILURE, error: regionData, entity });
                }
            } else {
                dispatch({
                    type: actionTypes.RESTORE_DATA_LOG_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.RESTORE_DATA_LOG_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const deleteDataLog = (id, entity, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_DATA_LOG_REQUEST });
            const res = await Service.deleteDataLog(id, entity, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.DELETE_DATA_LOG_SUCCESS, response: regionData, entity });
                } else {
                    dispatch({ type: actionTypes.DELETE_DATA_LOG_FAILURE, error: regionData, entity });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_DATA_LOG_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_DATA_LOG_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const deleteData = (id, entity, source = "") => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.DELETE_DATA_REQUEST });
            const res = await Service.deleteData(id, entity, source);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.DELETE_DATA_SUCCESS, response: regionData, entity });
                } else {
                    dispatch({ type: actionTypes.DELETE_DATA_FAILURE, error: regionData, entity });
                }
            } else {
                dispatch({
                    type: actionTypes.DELETE_DATA_FAILURE,
                    error: res.response && res.response.data,
                    entity
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.DELETE_DATA_FAILURE,
                error: e.response && e.response.data,
                entity
            });
        }
    };
};

const getDropdownList = (level, params) => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_DROPDOWN_REQUEST, level });
            const res = await Service.getDropdownList(level, params);
            if (res && res.status === 200) {
                const regionData = res.data;
                if (regionData.success) {
                    dispatch({ type: actionTypes.GET_DROPDOWN_SUCCESS, response: regionData, level });
                } else {
                    dispatch({ type: actionTypes.GET_DROPDOWN_FAILURE, error: regionData, level });
                }
            } else {
                dispatch({
                    type: actionTypes.GET_DROPDOWN_FAILURE,
                    error: res.response && res.response.data,
                    level
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_DROPDOWN_FAILURE,
                error: e.response && e.response.data,
                level
            });
        }
    };
};

const syncTemplateData = entity => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.SYNC_DATA_REQUEST });
            const res = await Service.syncData(entity);
            if (res && res.status === 200) {
                const regionData = res.data;
                dispatch({ type: actionTypes.SYNC_DATA_SUCCESS, response: regionData });
            } else {
                dispatch({
                    type: actionTypes.SYNC_DATA_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.SYNC_DATA_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getClientStandardStaticDropdown = entity => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_REQUEST });
            const res = await Service.getClientStandardStaticDropdown(entity);
            if (res && res.status === 200) {
                const regionData = res.data;
                dispatch({ type: actionTypes.CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_SUCCESS, response: regionData });
            } else {
                dispatch({
                    type: actionTypes.CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.CLIENT_STANDARD_STATIC_FIELD_DROPDOWN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};
const getClientStandardVisibleDropdown = id => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_REQUEST });
            const res = await Service.getClientStandardVisibleDropdown(id);
            if (res && res.status === 200) {
                const regionData = res.data;
                dispatch({ type: actionTypes.CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_SUCCESS, response: regionData });
            } else {
                dispatch({
                    type: actionTypes.CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.CLIENT_STANDARD_VISIBLE_FIELD_DROPDOWN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getManufacturerClients = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_ALL_MANUFACTURER_CLIENTS_REQUEST });
            const res = await Service.getManufacturerClients(params);

            if (res && res.status === 200) {
                const regionData = res;
                dispatch({ type: actionTypes.GET_ALL_MANUFACTURER_CLIENTS_SUCCESS, response: regionData });
            } else {
                dispatch({
                    type: actionTypes.GET_ALL_MANUFACTURER_CLIENTS_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_ALL_MANUFACTURER_CLIENTS_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

const getManufacturerClientDropdown = params => {
    return async dispatch => {
        try {
            dispatch({ type: actionTypes.GET_MANUFACTURER_CLIENT_DROPDOWN_REQUEST });
            const res = await Service.getManufacturerClientDropdown(params);

            if (res && res.status === 200) {
                dispatch({ type: actionTypes.GET_MANUFACTURER_CLIENT_DROPDOWN_SUCCESS, response: res.data });
            } else {
                dispatch({
                    type: actionTypes.GET_MANUFACTURER_CLIENT_DROPDOWN_FAILURE,
                    error: res.response && res.response.data
                });
            }
        } catch (e) {
            dispatch({
                type: actionTypes.GET_MANUFACTURER_CLIENT_DROPDOWN_FAILURE,
                error: e.response && e.response.data
            });
        }
    };
};

export default {
    getDataList,
    addData,
    getDataById,
    updateData,
    updateDataEntityParams,
    getListForCommonFilter,
    exportData,
    getAllDataLogs,
    restoreDataLog,
    deleteDataLog,
    deleteData,
    getDropdownList,
    syncTemplateData,
    getClientStandardStaticDropdown,
    getClientStandardVisibleDropdown,
    getManufacturerClients,
    getManufacturerClientDropdown
};
